import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getHomeHealthcareLog,
} from '../../../store/actions';
import Log from './log';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getHomeHealthcareLog,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Log);
